import { ApiError, type ApiErrorDetail } from './models/ApiError';

/** The ApiError itself, or the one Nuxt's `useAsyncData` wrapped as `cause` (it stores `createError(error)`). */
function toApiError(error: unknown): ApiError | undefined {
  if (error instanceof ApiError) return error;
  const cause = (error as { cause?: unknown } | null | undefined)?.cause;
  return cause instanceof ApiError ? cause : undefined;
}

/** The BFF error `code` carried by an ApiError's payload, if any. */
export function getApiErrorCode(error: unknown): string | undefined {
  return (toApiError(error)?.data as { code?: string } | undefined)?.code;
}

/** Whether `error` is an ApiError answered with this HTTP status. */
export function hasApiErrorStatus(error: unknown, status: number): boolean {
  return toApiError(error)?.status === status;
}

/** The `reason` of the BFF error detail called `name`, if any (e.g. `details[payment_authentication].reason`). */
export function getApiErrorDetailReason(error: unknown, name: string): string | undefined {
  const details = (toApiError(error)?.data as { details?: ApiErrorDetail[] } | undefined)?.details;
  return details?.find(detail => detail.name === name)?.reason;
}
